import * as React from 'react';

import InsertLinkOutlinedIcon from '@mui/icons-material/InsertLinkOutlined';
import { Button } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';
import { NavLink } from '@kamernet/core/Routing/NavLink';
import { useMediaIsDesktop } from '@kamernet/utilities/Media/useMediaIsDesktop';

import { getSocialMediaShareURLs } from '../../utilities';

import Facebook from './images/facebook.svg';
import Messenger from './images/messenger.svg';
import Whatsapp from './images/whatsapp.svg';
import styles from './SocialMediaControls.module.css';

export interface SocialMediaControlsProps {
  targetURL?: string;
}

export const SocialMediaControls = ({
  targetURL = undefined,
}: SocialMediaControlsProps) => {
  const { T } = useIntl();
  const isDesktop = useMediaIsDesktop();

  const {
    facebookShareUrl,
    fbMessengerShareUrl,
    whatsAppShareUrl,
    copyLinkUrl,
  } = getSocialMediaShareURLs(
    new URL(targetURL || window.location.href),
    !isDesktop,
  );

  const copyToClipboard = React.useCallback(() => {
    navigator.clipboard.writeText(copyLinkUrl).catch(() => {
      // ignore
    });
  }, [copyLinkUrl]);

  return (
    <div className={styles.root}>
      <Button
        className={styles.leftAlignedButton}
        fullWidth
        startIcon={<InsertLinkOutlinedIcon />}
        onClick={copyToClipboard}
      >
        {T('LBL_SH_SHARE_POPUP_COPYLINK')}
      </Button>
      <Button
        className={styles.leftAlignedButton}
        fullWidth
        component={NavLink.Anchor}
        href={facebookShareUrl}
        startIcon={<Facebook viewBox="0 0 20 20" />}
      >
        {T('LBL_FACEBOOK')}
      </Button>
      <Button
        className={styles.leftAlignedButton}
        fullWidth
        component={NavLink.Anchor}
        href={fbMessengerShareUrl}
        startIcon={<Messenger viewBox="0 0 20 20" />}
      >
        {T('lbl.facebook_messenger')}
      </Button>
      <Button
        className={styles.leftAlignedButton}
        fullWidth
        component={NavLink.Anchor}
        href={whatsAppShareUrl}
        startIcon={<Whatsapp viewBox="0 0 20 20" />}
      >
        {T('search_alert_modal.how_receive_alerts.whatsapp')}
      </Button>
    </div>
  );
};
